import { StatProps, Text } from "@bridgesplit/ui";
import { formatPercent, formatUsd } from "@bridgesplit/utils";
import { COPY } from "app/constants";

import { PortfolioTableStats, RewardPoint } from "./common";
import { useActivePortfolioRewardsSummary, usePortfolioStats } from "./util";

export default function LendVaultStats() {
    const lendVaultStats = usePortfolioStats()?.lendVaultStats;
    const portfolioRewards = useActivePortfolioRewardsSummary();
    const loading = !lendVaultStats || !portfolioRewards || portfolioRewards.isLoading;

    const stats: StatProps[] = [
        {
            value: <Text translate="no">{formatUsd(lendVaultStats?.totalValueUsd)}</Text>,
            caption: "Total supplied"
        },
        {
            value: formatPercent(lendVaultStats?.wAvgApy),
            caption: COPY.APY_TERM
        },
        {
            value: <RewardPoint points={portfolioRewards?.data?.activeLendVaultDailyPoints ?? 0} variant="body1" />,
            caption: COPY.DAILY_REWARDS_TERM
        }
    ];

    return <PortfolioTableStats stats={stats} loading={loading} />;
}
